import Vue from 'vue'

class Errors {
	/**
	 * Get errors started.
	 */
    constructor() {
        this.errors = {}
	}

	/**
	 * Set the errors from a JSON encoded Laravel errors bag object.
	 * @param {Object} errors
	 */
	set(errors) {
		this.errors = errors
	}

	/**
	 * Check if the given field has an error.
	 * @param {string} field
	 * @return {Boolean}
	 */
	has(field) {
		return this.errors.hasOwnProperty(field)
	}

	/**
	 * Get the error message for the given field.
	 * @param {String} field
	 * @return {String}
	 */
	get(field) {
		if (this.has(field)) {
			return this.errors[field][0]
		}
	}

	/**
	 * Get all error messages for the given field.
	 * @param {String} field
	 * @return {Array}
	 */
	getAll(field) {
		if (this.has(field)) {
			return this.errors[field]
		}
	}

	/**
	 * Get all errors.
	 *
	 */
	all() {
		return this.errors
	}

	/**
	 * Determine if there are any errors.
	 */
	any() {
		return Object.keys(this.errors).length > 0
	}

	/**
	 * Get all the errors in a flat array.
	 */
	flatten() {
		return Object.values(this.errors).reduce((a, b) => a.concat(b), [])
	}

	/**
	 * Clear the error message for the given field or all errors if no field is
     * specified.
	 * @param {String} field
	 */
	clear(field) {
		if (field) {
			Vue.delete(this.errors, field)
		} else {
			this.errors = {}
		}
	}
}

export default Errors



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-formit/src/errors.js
// module id = null
// module chunks = 